// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6211":"3cfc8c11","7833":"3cfc8c11"}[chunkId] + ".chunk.css";
};